export default __webpack_public_path__ + "static/media/ic_stats.02e2237b.svg";